import { render, staticRenderFns } from "./NewBill.vue?vue&type=template&id=96faadca&scoped=true&"
import script from "./NewBill.vue?vue&type=script&lang=js&"
export * from "./NewBill.vue?vue&type=script&lang=js&"
import style0 from "./NewBill.vue?vue&type=style&index=0&id=96faadca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96faadca",
  null
  
)

export default component.exports